/* ============================================================
   NOMARI PRE-ORDER · SINGLE CONFIG
   Catalog from market posters brief 2026-09-28.
   Prices: null = 「價錢待定 TBD」. Clicker bases have CAD prices.
   Photo: null = 「相片準備中」 placeholder.
   Street Glow stays OFF.
   ============================================================ */
// ---- SWEET LIGHT · BAMBOO PHOTOS (2026-10-02 ~15:10 PT: Lora's approved v2 set is live) ----
// Hero = slider slide 1, catalog card photo and Bamboo option thumbnail; picking Bamboo jumps to it. Set to null to hide all Bamboo
// photos again (Bamboo option then shows the 「相片準備中」 tile and the card falls back to the Apollo poster).
// Web files: scripts/make_images_bamboo_2026-10-02.py (1600×2000 → 1200×1500, proportional scale only). Old img/sweet-bamboo.* = backup only.
var NOMARI_SWEET_BAMBOO_PHOTO = "img/bamboo-light-hero-lit";
// Bamboo shell colours: used by the Bamboo variant's shell_colour option and by the extra-shell packs (2026-10-02).
var NOMARI_BAMBOO_SHELLS = [   // Atash 2026-10-02 19:30 PT: same 5 colours as the Nami Light cores (photos show matcha, light blue, pink)
  { id: "matcha",     name: "抹茶綠 Matcha green", hex: "#A9C27C" },
  { id: "light-blue", name: "淡藍 Light blue",    hex: "#BCDDF3" },
  { id: "light-pink", name: "淡粉紅 Light pink",  hex: "#F7C6D3" },
  { id: "yellow",     name: "黃 Yellow",          hex: "#F6D35B" },
  { id: "purple",     name: "紫色 Purple",        hex: "#B7A9EC" }
];
// Standalone shell packs: 1 = $8, 2 = $10 (C.prices keys above). With a lamp: only + 1 extra shell ($5), see the Bamboo variant.
var NOMARI_SHELL_PACKS = [ { n: 1, priceKey: "sweet-light:shell-1" }, { n: 2, priceKey: "sweet-light:shell-2" } ];
// Blind-box page copy (Writer v2, 2026-10-02). Set to false to keep the blind-box page without blurb/description (Atash to decide).
var NOMARI_BLINDBOX_COPY = true;

window.NOMARI_CONFIG = {
  currency: "CAD",
  // Official contact email (Atash 2026-10-02): the ONE place for it; contact.js shows it wherever the page has a [data-email] placeholder
  // (footer, info view, custom view + inquiry confirmation, checkout, order confirmation). Desktop → Gmail compose, phones → mailto.
  contactEmail: "nomaristudio@gmail.com",
  // Cache-bust version (images + CSS/config/gallery/logo refs in index.html). 2026-10-02 16:40 PT: home page + product desc + feature icons + Writer copy (trimmed) + Sweet Light prices/shells + cart Remove fix + blind box.
  // 2026-10-02 19:50 (published ~17:55 PT, Atash approved): Caveat slogan + admin labels on top of 19:00. (Caveat slogan removed in the 2026-10-03 lockup preview: brand rule, home card uses the official lockup SVG.)
  // 2026-10-02 19:00: perf (responsive images, CLS, main-thread) + Sweet Light split + contact email + hero restyle.
  // 2026-10-18 (preview, NOT published): HK Nostalgia re-launch (new photos, 7 items + 2 bundles, product shown again).
  assetVersion: "20261025-0100",
  assetUrl: function(src, ext){ return src + ext + "?v=" + this.assetVersion; },
  maxQty: 20,
  // ---- SHIPPING (home page → 市集及運送資料 / ?view=info) — the ONE place for every shipping number (2026-10-02, NOT decided yet) ----
  // null = not announced → info page shows 「運費及免運門檻稍後公佈」 / "Shipping rates & free-shipping threshold coming soon".
  // freeOver: e.g. 35 → 「滿 CAD $35 免運費」 / "Free shipping on orders over CAD $35".  flatFee: e.g. 8 → 「郵寄運費 CAD $8」 / "Shipping by post: CAD $8".
  // note: optional extra line, { zh: "…", en: "…" } (both languages, or null). Display-only: nothing here changes cart totals or orders.
  shipping: { freeOver: null, flatFee: null, note: null },
  // ---- NEXT MARKET (info page) — null = 「下次市集：稍後公佈」 / "Next market: to be announced" (Atash: no market in Oct 2026) ----
  // When decided: { zh: "10月… · 地點", en: "Oct … · place" } (display text only).
  nextMarket: null,
  // ---- HOME PAGE · FEATURED SLIDER (one real photo per main product; tap → ?p=<product>). Labels + alt text live in i18n.js (home["feat:<product>"] / home["featAlt:<product>"]). ----
  // Frame 1:1 with object-fit: contain (nothing cropped); the label sits in a strip under the photo, so it covers nothing.
  featured: [
    // 2026-10-18 (Atash): HK Nostalgia = featured/main product → slide 1. Others keep their order.
    { product: "hk-nostalgia", src: "img/hkn-morrison-01-poster" },   // 2026-10-18 re-launch: no group photo yet → Morrison poster (1:1)
    { product: "panel-light",  src: "img/panel-diamond-lit-pink-v7-aligned" },
    { product: "sweet-light",  src: "img/bamboo-light-hero-lit" },
    { product: "apollo-light", src: "img/sweet-strawberry-apollo-poster" },   // 2026-10-02 preview: Sweet Light split into 2 pages
    { product: "blind-box",    src: "img/blindbox-series-group-hero" },   // 2026-10-02 (preview)
    { product: "clicker",      src: "img/clicker-animals" },
    { product: "cross-stitch", src: "img/pocket-stitch-bear" },   // Pocket Stitch bear graphic (2026-10-02); old img/cross-stitch kept on disk
    { product: "crochet",      src: "img/crochet-howto" }
  ],
  // ---- PRICES (edit here) ----
  prices: {
    // Sweet Light prices (Atash, final 2026-10-02 16:15 PT).
    "sweet-light:bamboo": 20,        // 基本套裝 Basic set = 1 lamp with its own shell
    "sweet-light:addon-shell": 5,    // with a lamp: + 1 extra shell (set + 1 extra shell = $25); max 1 per lamp, no +2 with a lamp
    "sweet-light:strawberry": 20,    // Apollo (since the 2026-10-02 split: product apollo-light reads this key via variants[].priceKey)
    // Extra shells on their own (variant "extra-shell", returning customers or anyone):
    "sweet-light:shell-1": 8,        // 1 shell
    "sweet-light:shell-2": 10,       // 2 shells (bundle price, not 2 × $8)
    // Nami Light (id panel-light): base set = 1 core + 4 panels, CAD $20; choices = 5 cores / 10 patterns (Atash 2026-10-01)
    "panel-light:set": 20,
    // Nami Light add-ons (Atash 2026-09-30 20:17 PT). Counted once per order (not × sets).
    "panel-light:addon-core": 5,         // per extra core, any of the 5 colours
    "panel-light:addon-pattern": 3,      // per extra pattern panel
    "panel-light:addon-bundle": 10,      // every full bundle of extra panels (size = addons.groups[patterns].bundleSize, 4) → $10 instead of $12
    // 老孖利士多盲盒 Nomari Store Blind Box (Atash via Accountant, 2026-10-02 18:42 PT). One key per option (= per box/set, × qty).
    "blind-box:random": 12,          // 1 random box (cheapest)
    "blind-box:random-2": 22,        // 2 random boxes together (deal: $22 instead of 2 × $12)
    "blind-box:biscuits": 14,        // pick your own
    "blind-box:cooler": 14,
    "blind-box:beer-crate": 15,
    "blind-box:bakery": 16,          // rare
    "blind-box:full-set": 50,        // all four (biscuits + cooler + beer crate + bakery)
    // HK Nostalgia (Atash 2026-10-18). Accountant SKUs in comments. One key per option (= per piece / per bundle, × qty).
    "hk-nostalgia:morrison": 15,           // NM-SI-D  安全島燈 Morrison Signal Light (desk)
    "hk-nostalgia:red-pendant": 15,        // NM-RA-D  紅A燈 Red A Desk Lamp
    "hk-nostalgia:letterbox": 12,          // NM-MB-D  舊式信箱（大）Vintage Mailbox Card Holder
    "hk-nostalgia:morrison-keychain": 8,   // (no SKU given yet) 安全島燈匙扣 Morrison Signal Keychain
    "hk-nostalgia:taxi": 10,               // NM-TX-K  的士燈匙扣 Taxi Lamp Keychain
    "hk-nostalgia:red-a-keychain": 6,      // NM-RA-K  紅A燈迷你匙扣 Red A Mini Keychain
    "hk-nostalgia:mailbox-magnet": 6,      // NM-MB-K  舊式信箱細磁石 Mini Mailbox Magnet
    "hk-nostalgia:combo-duo": 15,          // 組合一 = 的士燈匙扣 + 任揀 1 個細匙扣 (red-a-keychain / mailbox-magnet / morrison-keychain), pick in combo_pick
    "hk-nostalgia:combo-trio": 20,         // 組合二 三件套 = 的士燈匙扣 + 紅A燈迷你匙扣 + 舊式信箱細磁石
    "clicker:1x1": 6,
    "clicker:3x1": 10,
    "clicker:4x1": 12,
    "clicker:5x1": 15,
    "cross-stitch:standard": null,
    "crochet:custom": null
  },
  // Optional per product: features: ["usb", "dimmable", …] (keys in icons.js) → icon chips under the price; none = no row.
  // Optional per product: desc: { zh: "…", en: "…" } → description box under the product-page slider (above the options).
  // Blank line = new paragraph; single line break = line break. Missing or empty = nothing shown. HK Traditional Chinese only. (2026-10-02)
  products: [
    // 2026-10-18 (Atash): hk-nostalgia moved to the top of the catalog (before the lights); others keep their order.
    {
      // HK Nostalgia re-launch (2026-10-18, preview). Old variant ids morrison / red-pendant / letterbox / taxi kept (old orders + price keys);
      // new ids morrison-keychain / red-a-keychain / mailbox-magnet + bundles combo-duo / combo-trio. Old img/hk-* photos removed (in the backup).
      // Photos = Atash's final marketing images (logo + slogan baked in), uniform resize only: scripts/make_images_hk_relaunch_2026-10-18.py.
      id: "hk-nostalgia",
      name: "HK 懷舊",
      en: "Hong Kong nostalgia lights & keychains",
      blurb: "香港街頭懷舊小夜燈同匙扣：安全島燈、紅A燈、舊式信箱、的士燈，仲有匙扣組合。",
      blurbEn: "Little lights and keychains from Hong Kong streets: the Morrison signal light, Red A lamp, vintage mailbox and taxi lamp, plus keychain bundles.",
      desc: { zh: "呢啲都係香港街頭每日見到、卻好少人留意嘅事物。我哋將佢哋縮細，保留顏色同細節，做成枱面小夜燈同隨身匙扣。\n\n想要真正大隻嘅的士車頂燈？可以喺「訂製查詢」同我哋傾，按你要求訂造。",
              en: "Everyday sights of Hong Kong streets that most people walk past. We've scaled them down, kept the colours and details, and made them into desk lights and keychains.\n\nWant a full-size taxi roof lamp? It can be made to order: ask us on the Custom order page." },
      features: ["keychain"],   // feature icon chips (icons.js keys)
      photo: "img/hkn-morrison-01-poster",   // no group photo yet → Morrison poster as cover (catalog card + home slider)
      ratio: "1 / 1",
      photoAlt: "安全島燈海報 Morrison Signal Light poster",
      variantCards: true,   // product page: options as photo cards; no photo → 「相片稍後更新 / Photo coming soon」 tile (app.js renderVariants)
      // Slider: all 6 are designed posters with their own text + logo (top-left on some) → caption: false on every slide.
      // variant: "<id>" = picking that option jumps here. taxi-03 shows a big taxi roof lamp in the background: NOT sold (custom order only, see desc).
      gallery: [
        { src: "img/hkn-morrison-01-poster",   alt: "安全島燈海報 Morrison Signal Light poster", variant: "morrison" },
        { src: "img/hkn-morrison-02-features", alt: "安全島燈特點：枱燈、Type-C 供電、隨機香港街招、小夜燈 Morrison Signal Light features", caption: false },
        { src: "img/hkn-morrison-03-box",      alt: "安全島燈同膠盒內嘅細匙扣；匙扣款只包括膠盒內嘅細匙扣 Morrison Signal Light and the small keychain in its acrylic case (keychain option: small keychain in acrylic case only)", caption: false, variant: "morrison-keychain" },
        { src: "img/hkn-taxi-01-poster",       alt: "的士燈匙扣海報 Taxi Lamp Keychain poster", caption: false, variant: "taxi" },
        { src: "img/hkn-taxi-02-features",     alt: "的士燈匙扣特點：可換電池、NFC、小夜燈 Taxi Lamp Keychain features", caption: false },
        { src: "img/hkn-taxi-03-pair",         alt: "的士燈匙扣，後面大的士燈只係背景 Taxi Lamp Keychain (the big lamp behind is background only)", caption: false }
      ],
      variants: [
        // desk pieces
        { id: "morrison",          name: "安全島燈 Morrison Signal Light",       note: "枱燈 · Desk light", photo: "img/hkn-morrison-01-poster" },
        { id: "red-pendant",       name: "紅A燈 Red A Desk Lamp",            note: "經典紅色膠燈罩 · Classic red lampshade", photoPending: true },
        { id: "letterbox",         name: "舊式信箱（大）Vintage Mailbox Card Holder", note: "卡片座 · Card holder", photoPending: true },
        // keychains / small pieces
        { id: "morrison-keychain", name: "安全島燈匙扣 Morrison Signal Keychain", note: "只包括膠盒內嘅細匙扣 · Small keychain in acrylic case only", photo: "img/hkn-morrison-03-box",
          // Atash 2026-10-18: the photo also shows the desk lamp, packaging + street posters → scope note on the card, catalog tile and cart line
          scope: "只包括膠盒內嘅細匙扣 · Small keychain in acrylic case only", photoAlt: "安全島燈匙扣：只包括膠盒內嘅細匙扣 Morrison Signal Keychain: small keychain in acrylic case only" },
        { id: "taxi",              name: "的士燈匙扣 Taxi Lamp Keychain",         note: "匙扣 · Keychain", photo: "img/hkn-taxi-01-poster" },
        { id: "red-a-keychain",    name: "紅A燈迷你匙扣 Red A Mini Keychain",     note: "匙扣 · Keychain", photoPending: true },
        { id: "mailbox-magnet",    name: "舊式信箱細磁石 Mini Mailbox Magnet",    note: "磁石 · Magnet", photoPending: true },
        // bundles = their own options (like blind-box random-2 / full-set): one price key each, cart line total = bundle price × qty.
        { id: "combo-duo", bundle: 2, name: "組合一 Keychain duo", note: "組合 · Bundle",
          hint: "的士燈匙扣＋任揀一個細匙扣 · Taxi Lamp Keychain + 1 small piece of your choice",
          // the small piece is picked here; stored as combo_pick on the cart line (items_json) + in product_label / items_summary (no new Site Data field)
          options: [ { id: "combo-pick", field: "combo_pick", label: "細匙扣 Small piece", hint: "任揀一個 · Pick 1", required: true, type: "chips",
            choices: [
              { id: "red-a-keychain",    name: "紅A燈迷你匙扣 Red A Mini Keychain" },
              { id: "mailbox-magnet",    name: "舊式信箱細磁石 Mini Mailbox Magnet" },
              { id: "morrison-keychain", name: "安全島燈匙扣 Morrison Signal Keychain" }
            ] } ] },
        { id: "combo-trio", bundle: 3, name: "組合二 三件套 Trio", note: "組合 · Bundle",
          hint: "的士燈匙扣＋紅A燈迷你匙扣＋舊式信箱細磁石 · Taxi Lamp Keychain + Red A Mini Keychain + Mini Mailbox Magnet" }
      ]
    },
    {
      // Bamboo Chocolate Light page (2026-10-02 preview split): key "sweet-light" kept so old ?p=sweet-light links, price keys and orders still work.
      // Apollo moved to its own page (id "apollo-light", below). Display names live in i18n.js products[...] (en series name: Mega Choco Light).
      id: "sweet-light",
      defaultVariant: "bamboo",   // Atash 2026-10-02 19:29 PT: show the set + extra-shell add-on straight away
      name: "Bamboo Chocolate Light 竹筍朱古力燈",
      en: "Mega Choco Light",
      // Copy: Writer product copy v2 (copy/product-desc-v2-2026-10-02.md), A = blurb (spec line under price), B = desc (intro under photos). Verbatim;
      // 16:30 PT (Atash): spec words the feature icons already show were deleted from A (words removed only, nothing added).
      // Split (2026-10-02): Writer's sweet-light desc divided — Bamboo keeps the Takenoko no Sato clause, Apollo the Apollo clause; the opening
      // and closing sentences are Writer's words on both pages (no new copy).
      blurb: "朱古力造型小夜燈。三色光，可調光，USB 供電。",
      blurbEn: "A chocolate-shaped night light. Three light colours, dimmable, USB powered.",
      desc: { zh: "造型取材自竹筍形朱古力餅，以 3D 打印逐層造出佢嘅輪廓。燈殼可以更換顏色，一盞燈可以有唔同面貌。光線柔和，適合床頭或者書枱，伴你度過安靜嘅夜晚。", en: "Inspired by the little bamboo-shoot chocolate biscuits and 3D printed layer by layer to capture their shape. The shell can be swapped for a different colour, so one lamp can take on more than one look. Its soft glow suits a bedside or a desk at night." },
      features: ["modes3", "usb", "dimmable", "swap-shell"],   // feature icon chips (icons.js keys)
      // Catalog card photo = Bamboo hero (4:5, fills the 4:5 card box exactly → no crop).
      photo: NOMARI_SWEET_BAMBOO_PHOTO,
      ratio: "4 / 5",
      photoAlt: "竹筍朱古力燈，粉紅光 Bamboo Chocolate, pink light",
      // Slider: the 6 Bamboo photos only (hero first, no caption — slide 1 never has a pill; slides 2–6 captioned). Captions are "中文 · English" strings.
      // variant: "<id>" = picking that variant jumps the slider to this slide (app.js variant change handler).
      gallery: NOMARI_SWEET_BAMBOO_PHOTO ? [
        { src: NOMARI_SWEET_BAMBOO_PHOTO,      alt: "竹筍朱古力燈，粉紅光 Bamboo Chocolate, pink light", variant: "bamboo" },  // slide 1: never a caption pill (Atash standing rule)
        { src: "img/bamboo-light-lit-cyan",    alt: "竹筍朱古力燈，青色光 Bamboo Chocolate, cyan light",   caption: "青色光 · Cyan light" },
        { src: "img/bamboo-light-lit-green",   alt: "竹筍朱古力燈，綠色光 Bamboo Chocolate, green light",  caption: "綠色光 · Green light" },
        { src: "img/bamboo-light-unlit-01",    alt: "竹筍朱古力燈，未亮燈 Bamboo Chocolate, unlit",        caption: "未亮燈 · Unlit" },
        { src: "img/bamboo-light-unlit-02",    alt: "竹筍朱古力燈同另外兩個燈殼，未亮燈 Bamboo Chocolate with two more shells, unlit", caption: "可換燈殼 · Swappable shells", variant: "extra-shell" },
        { src: "img/bamboo-light-angle-01",    alt: "竹筍朱古力燈斜角，連兩個燈殼 Bamboo Chocolate, angle view with two shells",  caption: "斜角 · Angle view" }
      ] : [],
      variants: [
        {
          id: "bamboo",
          name: "Bamboo Chocolate 竹筍朱古力",
          note: "20cm · 可換燈殼",
          photo: NOMARI_SWEET_BAMBOO_PHOTO,   // catalog option thumbnail (null → neutral 「相片準備中 Photo coming soon」 tile)
          photoPending: !NOMARI_SWEET_BAMBOO_PHOTO,
          // The square thumb would cut the tall lamp with cover → show the whole 4:5 hero contained, side bars = hero's own edge colour.
          photoFit: "contain", photoBg: "#855577",
          options: [
            {
              id: "shell",
              field: "shell_colour",
              label: "燈殼色 Shell colour",
              required: true,
              type: "swatch",
              choices: NOMARI_BAMBOO_SHELLS
            }
          ],
          // Set choice (final 2026-10-02 16:15 PT): 基本套裝（燈連燈殼）Basic set $20, or 加多 1 個燈殼 Add 1 extra shell +$5 (= $25),
          // customer picks the extra shell's colour. Per lamp; line total = ($20 + $5 if extra) × quantity. Order fields are the same as
          // the Nami add-ons: addons (JSON {"shells":{colour:qty}}), addon_count, addons_label, addon_subtotal, addon_breakdown, total_price.
          // featured: 1 = "set + 1 extra shell" is listed first, pre-selected and badged 推介 / Recommended (Atash 2026-10-02 16:18 PT).
          shellPack: { mode: "addon", label: "加購燈殼 Extra shell", basicLabel: "基本套裝（燈連燈殼）Basic set (lamp + shell)", featured: 1,
                       packs: [ { n: 1, priceKey: "sweet-light:addon-shell" } ], colours: NOMARI_BAMBOO_SHELLS }
        },
        {
          // Extra Bamboo shells on their own, for returning customers (2026-10-02 16:05 PT): 1 for $8 or 2 for $10, colour pick per shell.
          // Line unit_price = pack price, quantity = number of packs. No lamp. Price range on the catalog card ignores this variant.
          id: "extra-shell",
          name: "加購燈殼（單買）Extra shell (on its own)",           // zh/en display via i18n.js variantMap
          note: "1 個 $8 · 2 個 $10 · 唔連燈",
          photo: "img/bamboo-light-unlit-02",   // Bamboo lamp with two more shells (4:5, contained in the square thumb)
          photoFit: "contain", photoBg: "#D8CCC7",
          shellPack: { mode: "standalone", label: "燈殼 Shells", packs: NOMARI_SHELL_PACKS, colours: NOMARI_BAMBOO_SHELLS }
        }
      ]
    },
    {
      // Strawberry Apollo Light page (2026-10-02 preview split from sweet-light). Price key stays "sweet-light:strawberry" (variants[].priceKey)
      // so admin and old orders still read it; old carts with sweet-light/strawberry lines are moved to this product on load (app.js).
      id: "apollo-light",
      name: "Strawberry Apollo Light 士多啤梨 Apollo 燈",
      en: "Mega Choco Light",
      blurb: "朱古力造型小夜燈。三色光，可調光，USB 供電。",
      blurbEn: "A chocolate-shaped night light. Three light colours, dimmable, USB powered.",
      desc: { zh: "造型取材自經典士多啤梨朱古力，保留咗雙色錐形。好多人細個都食過，我哋將呢份記憶做成一盞小燈，擺喺床頭或者書枱都合適。", en: "Inspired by the classic strawberry chocolate, keeping its two-tone cone. It's a sweet many of us grew up with, and we've turned that memory into a small lamp for a bedside or a desk." },
      features: ["modes3", "usb", "dimmable"],
      photo: "img/sweet-strawberry-apollo-poster",
      ratio: "3 / 4",
      photoAlt: "Strawberry Chocolate 士多啤梨朱古力燈 海報",
      // one slide: the Apollo poster (no caption: slide 1 never has one, and it would cover the poster's own title)
      gallery: [ { src: "img/sweet-strawberry-apollo-poster", alt: "Strawberry Chocolate 士多啤梨朱古力燈 海報", caption: false, variant: "strawberry" } ],
      variants: [
        {
          id: "strawberry",
          priceKey: "sweet-light:strawberry",   // unchanged key (CAD $20)
          name: "Strawberry Chocolate 士多啤梨朱古力",
          note: "12cm · 連迷你匙扣 · 粉紅／啡 as shown",
          photo: "img/sweet-strawberry-apollo-thumb"   // 400×400 real-pixel crop of the lamp area from the poster (whole lamp visible)
        }
      ]
    },
    {
      id: "panel-light", // id kept for back-compat; display name = Nami Light (Atash 2026-09-30)
      name: "Nami Light",
      en: "Nami Light · 換燈芯 · 換圖案面板",
      // Copy: Writer product copy v2 (copy/product-desc-v2-2026-10-02.md), A = blurb (spec line under price), B = desc (intro under photos). Verbatim;
      // 16:30 PT (Atash): spec words the feature icons already show were deleted from A (words removed only, nothing added).
      blurb: "基本套裝有 1 個燈芯（{{core_count}} 色揀 1）同 4 塊圖案面板（{{pattern_count}} 款任揀）。",
      blurbEn: "The base set includes 1 colour core (choose from {{core_count}}) and 4 pattern panels (choose from {{pattern_count}}).",
      desc: { zh: "燈芯可以換顏色，圖案面板可以換花紋，包括麻葉、青海波、菱格同竹林等傳統圖案。換一塊面板，就可以為房間換一種氣氛。", en: "Change the core for a different colour, or the panels for another traditional pattern, such as asanoha (hemp leaf), seigaiha waves, diamond lattice or bamboo grove. A new panel is all it takes to change the feel of a room." },
      features: ["swap-core", "swap-panel", "usb", "dimmable"],   // feature icon chips (icons.js keys)
      photo: "img/panel-hero-logo",
      ratio: "4 / 5",          // Lora's v2 photos are 4:5 (1600×2000 → 1000×1250); card + slider use exact 4:5 boxes, no crop
      photoAlt: "Nami Light（麻葉面板，粉紅光）",
      howItWorks: {
        title: "點樣用 How it works",
        items: [
          { src: "img/mm-how-01", alt: "換燈芯：替換燈芯改變燈光顏色", caption: "換燈芯 · Swap cores" },
          { src: "img/mm-how-03", alt: "替換圖案面板：換面板改變外觀", caption: "換圖案面板 · Swap pattern panels" }
        ]
      },
      // Atash-approved Nami Light v7 slider: unchanged poster, four uncropped v7 frames, then the existing 6801 star-lattice slide.
      // All photo frames are 4:5; the poster is kept intact and contained in the same 4:5 slider box.
      // Caption pills are rendered top-left so they do not cover the v7 logo badge at bottom-right.
      // 2026-10-02 14:40 PT (Atash): Asanoha pink + Star lattice yellow slides removed (img/*-aligned + originals kept as backups).
      // Picking Asanoha / Star lattice therefore has no slide to jump to → slider stays put (app.js: indexOf -1 → no goTo).
      // 2026-10-02: the slides use the "-aligned" files (scripts/make_images_nami_aligned_2026-10-02.py): uniform scale + crop only,
      // lamp body 1155/1500 px tall, centre x 600, top y 128, baseline y 1283 in every frame (originals kept in img/).
      gallery: [
        { src: "img/nami-light-cover",                  alt: "Nami Light 封面海報" },
        { src: "img/panel-diamond-lit-pink-v7-aligned",  alt: "菱格 Diamond lattice 粉紅燈光", caption: "菱格 Diamond · 粉紅 Pink core", pattern: "diamond", core: "light-pink" },
        { src: "img/panel-diamond-lit-lavender-v7-aligned",  alt: "菱格 Diamond lattice 紫色燈光", caption: "菱格 Diamond · 紫色 Purple core", pattern: "diamond", core: "purple" },
        { src: "img/panel-big-star-lit-yellow-v7-aligned",  alt: "大星 Big star 黃色燈光", caption: "大星 Big star · 黃色 Yellow core", pattern: "big-star", core: "yellow" }
      ],
      options: [
        {
          id: "core",
          field: "core_colour",
          label: "燈芯色 Core colour",
          hint: "套裝包 1 個燈芯 · 1 core included",
          required: true,
          type: "swatch",
          choices: [
            { id: "yellow",     name: "黃 Yellow",          hex: "#F6D35B" },
            { id: "light-pink", name: "淡粉紅 Light pink",  hex: "#F7C6D3" },
            { id: "light-blue", name: "淡藍 Light blue",    hex: "#BCDDF3" },
            { id: "matcha",     name: "抹茶綠 Matcha green", hex: "#A9C27C" },
            { id: "purple",     name: "紫色 Purple",        hex: "#B7A9EC" } // confirmed 2026-09-30; hex ≈ lavender glow in img/panel-core-purple (gallery item core:"purple")
          ]
        }
      ],
      // 4 included panel slots; each can use any of the 10 approved patterns. Repeats allowed.
      patternSlots: {
        count: 4,
        field: "patterns",
        label: "揀 4 款圖案 Choose 4 patterns",
        hint: "套裝包 4 塊面板，可以重複揀同一款 · 4 panels included; repeats OK",
        allowRepeats: true,
        // tile = full tall STL panel render for picker / slot / add-on thumbnails (2026-10-01); photo = real photo (slider jump uses gallery[].pattern)
        choices: [
          { id: "asanoha",      name: "麻葉 Asanoha",         short: "麻葉",   photo: "img/panel-asanoha", tile: "img/tile-asanoha" },
          { id: "nami",         name: "青海波 Seigaiha",      short: "青海波", photo: "img/panel-seigaiha", tile: "img/tile-nami" },
          { id: "ripple",       name: "波紋 Ripple",          short: "波紋",   photo: "img/panel-ripple", tile: "img/tile-ripple" },
          { id: "diamond",      name: "菱格 Diamond lattice", short: "菱格",   photo: "img/panel-diamond", tile: "img/tile-diamond" },
          { id: "star-lattice", name: "星格 Star lattice",    short: "星格",   photo: "img/panel-star-lattice", tile: "img/tile-star-lattice" },
          { id: "big-star",     name: "大星 Big star",        short: "大星",   photo: "img/panel-big-star", tile: "img/tile-big-star" },
          { id: "tairin",       name: "大輪 Tairin",          short: "大輪",   tile: "img/tile-tairin" },
          { id: "chikurin",     name: "竹林 Chikurin",        short: "竹林",   tile: "img/tile-chikurin" },
          { id: "shimobana",    name: "霜花 Shimobana",        short: "霜花",   tile: "img/tile-shimobana" },
          { id: "goma",         name: "胡麻 Goma",             short: "胡麻",   tile: "img/tile-goma" }
        ]
      },
      // Optional add-ons (extra cores per colour, extra patterns per pattern). Prices → C.prices["panel-light:addon-*"].
      addons: {
        maxEach: 10,
        groups: [
          { id: "cores",    label: "加購燈芯 Extra cores",       from: "option:core_colour", priceKey: "panel-light:addon-core", unitWord: "個" },
          { id: "patterns", label: "加購圖案面板 Extra patterns", from: "patternSlots",       priceKey: "panel-light:addon-pattern", unitWord: "塊",
            bundleSize: 4, bundlePriceKey: "panel-light:addon-bundle" }   // pattern_addon = floor(n/4)×$10 + (n%4)×$3 across all patterns
        ]
      },
      variants: [
        { id: "set", name: "基本套裝 Base set", note: "1 燈芯 + 4 面板" }
      ]
    },
    {
      // 老孖利士多盲盒 Nomari Store Blind Box (2026-10-02, preview). 9 Atash-approved real photos from
      // nomari-products/pre-order-photos/finished/blindbox/ (1600×2000 → 1200×1500 uniform Lanczos scale, no crop/recolour).
      // Options: 隨機盲盒 ×1 / ×2, the 4 models (西餅盒 bakery = rare; names per Accountant/Atash 2026-10-02 19:09 PT: 什餅罐 / 冰桶 / 啤酒箱 / 西餅盒), or the full set of 4. Prices in prices["blind-box:*"] (Atash 2026-10-02 18:42 PT).
      id: "blind-box",
      name: "老孖利士多盲盒 Nomari Store Blind Box",
      en: "迷你士多模型 · Miniature store sets",   // card subtitle (zh/en via i18n walker)
      blurb: NOMARI_BLINDBOX_COPY ? "四款香港士多主題盲盒：什餅罐、西餅盒、啤酒箱、冰桶。" : "",
      blurbEn: NOMARI_BLINDBOX_COPY ? "Four Hong Kong tuck shop blind box sets: Biscuit tin, Bakery box, Beer crate and Cooler." : "",
      desc: NOMARI_BLINDBOX_COPY ? { zh: "老孖利士多將舊式士多嘅日常縮成掌心大小：一罐什餅、一桶汽水、一箱啤酒。可以自選款式，亦可以揀隨機盲盒，等開盒嗰一刻先知道係邊款。", en: "Nomari Store shrinks the everyday life of an old Hong Kong tuck shop to palm size: a tin of biscuits, a cooler of drinks, a crate of beer. Choose your set, or go for the random box and find out when you open it." } : null,
      photo: "img/blindbox-store-poster-hero",   // Atash 2026-10-02 19:36 PT: store poster = main photo; 4-set group photo moved to slide 2
      ratio: "4 / 5",
      photoAlt: "老孖利士多盲盒海報 Nomari Store Blind Box poster",
      // Slide 1 = series group hero, NO caption (standing rule). variant: "<id>" = picking that option jumps here.
      gallery: [
        { src: "img/blindbox-store-poster-hero", alt: "老孖利士多盲盒海報 Nomari Store Blind Box poster", variant: "random" },
        { src: "img/blindbox-series-group-hero", alt: "老孖利士多盲盒，4 款合照 Nomari Store Blind Box, all 4 sets", caption: "4 款合照 · All 4 sets" },   // M1 2026-10-03: own caption (i18n.js map) instead of the mixed alt
        { src: "img/blindbox-biscuits-wide",     alt: "什餅罐盲盒 Biscuit tin set",               caption: "什餅罐 · Biscuit tin", variant: "biscuits" },
        { src: "img/blindbox-bakery-wide",       alt: "西餅盒盲盒 Bakery box set",                 caption: "西餅盒 · Bakery box", variant: "bakery" },
        { src: "img/blindbox-beer-crate-wide",   alt: "啤酒箱盲盒 Beer crate set",                 caption: "啤酒箱 · Beer crate", variant: "beer-crate" },
        { src: "img/blindbox-fridge-wide",       alt: "冰桶盲盒 Cooler set",                       caption: "冰桶 · Cooler", variant: "cooler" }
      ],
      textFields: [
        {
          id: "design-note",
          field: "design_note",      // stored like the cross-stitch note (admin shows it under Options)
          label: "備註（可選） Note (optional)",
          placeholder: "其他要求 · Anything else",
          maxlength: 200,
          required: false
        }
      ],
      variants: [
        // Order (Atash 2026-10-02 18:42 PT): random options first (cheapest), then pick-your-own, then the full set. badge: "rare" → 稀有 / Rare pill.
        { id: "random",     name: "隨機盲盒 Blind box (random)", note: "隨機抽 1 盒 · 1 random box",
          hint: "隨機抽，比自選平 · Random pick, cheaper than choosing",   // shown under the option chip on the product page
          photo: "img/blindbox-series-group-hero", photoFit: "contain", photoBg: "#CDC9BF" },
        { id: "random-2",   name: "隨機盲盒 2 盒 2 random boxes", note: "2 盒優惠價 · 2-box deal", hint: "2 盒優惠價 · 2-box deal",
          photo: "img/blindbox-series-group-hero", photoFit: "contain", photoBg: "#CDC9BF" },
        { id: "biscuits",   name: "什餅罐 Biscuit tin", note: "自選款式 · Pick this set", photo: "img/blindbox-biscuits-wide",   photoFit: "contain", photoBg: "#856B52" },
        { id: "cooler",     name: "冰桶 Cooler",        note: "自選款式 · Pick this set", photo: "img/blindbox-fridge-wide",     photoFit: "contain", photoBg: "#8D7152" },
        { id: "beer-crate", name: "啤酒箱 Beer crate",   note: "自選款式 · Pick this set", photo: "img/blindbox-beer-crate-wide", photoFit: "contain", photoBg: "#7E634B" },
        { id: "bakery",     name: "西餅盒 Bakery box",  note: "自選款式 · Pick this set", badge: "rare", photo: "img/blindbox-bakery-wide",     photoFit: "contain", photoBg: "#83694F" },
        { id: "full-set",   name: "全套 4 款 Full set of 4", note: "什餅罐、冰桶、啤酒箱、西餅盒各 1 · One of each", hint: "4 款各 1 盒 · One of each of the 4",
          photo: "img/blindbox-series-group-hero", photoFit: "contain", photoBg: "#CDC9BF" }
      ]
    },
    {
      id: "clicker",
      marketOnly: true,   // Atash 2026-10-02 20:13 PT: no online orders for Clicker; page shows 市集限定 instead of the order form
      name: "Animal Clicker 動物 Clicker",
      en: "Build your clicker · tactile · beads · 3D printed",
      // Copy: Writer product copy v2 (copy/product-desc-v2-2026-10-02.md), A = blurb (spec line under price), B = desc (intro under photos). Verbatim.
      blurb: "揀底座尺寸、角色同底座顏色，亦可以加字母珠。角色同顏色可以自由配搭，唔肯定嘅話可以寫低備註。",
      blurbEn: "Choose a base size, a character and a base colour, with optional alphabet beads. Characters and colours can be mixed freely; leave a note if you're unsure.",
      desc: { zh: "一款由你親手配搭嘅動物 clicker。選好角色同顏色，再加上名字或者字母，就係專屬於你嘅一件。按鍵手感清脆，適合工作或者溫書時放鬆一下。", en: "An animal clicker you put together yourself. Choose the character and colours, add a name or initials, and it becomes yours alone. The crisp click makes it a small break between work or study." },
      features: ["diy"],   // feature icon chips (icons.js keys)
      photo: "img/clicker-animals",
      ratio: "1 / 1",
      photoAlt: "Animal Clicker Keychain 角色示範",
      options: [
        {
          id: "character",
          field: "character",
          label: "角色 Character",
          required: true,
          type: "chips",
          choices: [
            { id: "duckling", name: "小鴨 Duckling" },
            { id: "unicorn", name: "獨角獸 Unicorn" },
            { id: "elephant", name: "大象 Elephant" },
            { id: "otter", name: "水獺 Otter" },
            { id: "sheep", name: "綿羊 Sheep" }
          ]
        },
        {
          id: "base-colour",
          field: "base_colour",
          label: "底座色 Base colour",
          required: true,
          type: "swatch",
          hint: "底座色同角色可以隨意配搭，唔肯定可以寫低備註。 · Any character goes with any base colour. Not sure? Leave a note.",   // Writer 2026-10-02
          choices: [
            { id: "yellow", name: "黃 Yellow", hex: "#F5D76E" },
            { id: "purple", name: "紫 Purple", hex: "#B39DDB" },
            { id: "blue", name: "藍 Blue", hex: "#7EB8DA" },
            { id: "brown", name: "啡 Brown", hex: "#A67C52" },
            { id: "green", name: "綠 Green", hex: "#8FCB9B" },
            { id: "white", name: "白 White", hex: "#F5F2EA" },
            { id: "pink", name: "粉紅 Pink", hex: "#F4A7C0" }
          ]
        }
      ],
      textFields: [
        {
          id: "beads",
          field: "beads",
          label: "字母珠（可選）Alphabet beads",
          placeholder: "例如名字／字母 · e.g. NOMARI",
          maxlength: 24,
          required: false
        }
      ],
      variants: [
        { id: "1x1", name: "Single 1×1", note: "CAD $6" },
        { id: "3x1", name: "3-Slot 3×1", note: "CAD $10" },
        { id: "4x1", name: "4-Slot 4×1", note: "CAD $12" },
        { id: "5x1", name: "5-Slot 5×1", note: "CAD $15" }
      ]
    },
    {
      id: "cross-stitch",
      name: "隨身繡 十字繡匙扣 Pocket Stitch Cross-stitch Keychain",   // Pocket Stitch／隨身繡 series (Writer/Atash 2026-10-02); id + price keys unchanged
      en: "Handmade cross-stitch keychain",
      // Copy: Writer product copy v2 (copy/product-desc-v2-2026-10-02.md), A = blurb (spec line under price), B = desc (intro under photos). Verbatim.
      blurb: "手工十字繡匙扣。請喺下面備註寫低想要嘅款式同顏色，我哋會再同你確認。",
      blurbEn: "Handmade cross-stitch keychain. Write the design and colours you'd like in the note below, and we'll confirm with you.",
      desc: { zh: "每一針都係人手完成，所以每件都有少少分別。尺寸細小，適合掛喺袋或者鎖匙，係一份帶住心意嘅小禮物。", en: "Every stitch is done by hand, so no two pieces are quite the same. Small enough for a bag or a set of keys, it makes a thoughtful little gift." },
      features: ["handmade", "keychain"],   // feature icon chips (icons.js keys)
      photo: "img/pocket-stitch-bear",   // bear graphic, slogan fixed to "turn thoughts into gifts" (scripts/make_images_pocket_stitch_bear_2026-10-02.py). Was img/cross-stitch (round stitched piece), file kept.
      ratio: "1 / 1",
      photoAlt: "隨身繡 十字繡匙扣：啤啤熊款 Pocket Stitch cross-stitch keychain, bear design",
      textFields: [
        {
          id: "design-note",
          field: "design_note",
          label: "顏色／設計備註 Colour / design note",
          placeholder: "例如：啡熊＋彩虹花 · e.g. brown bear + flower",
          maxlength: 200,
          required: false
        }
      ],
      variants: [
        { id: "standard", name: "十字繡匙扣 Standard", note: "款式待定 · design TBD" }
      ]
    },
    {
      id: "crochet",
      name: "Crochet／訂製手工",
      en: "Crochet & custom handmade",
      // Copy: Writer product copy v2 (copy/product-desc-v2-2026-10-02.md), A = blurb (spec line under price), B = desc (intro under photos). Verbatim.
      blurb: "標準款可以喺呢度預訂。如需完全訂製，請 IG DM @nomari.studio。",
      blurbEn: "Standard pieces can be pre-ordered here. For fully custom work, DM us on Instagram @nomari.studio.",
      desc: { zh: "每件都係人手一針一針鈎織，保留手作獨有嘅質感同溫度。如果想要特別款式或者完全訂製，歡迎 IG DM @nomari.studio 同我哋傾。", en: "Each piece is crocheted by hand, stitch by stitch, with the texture and warmth only handwork has. For a special design or a fully custom piece, DM us on Instagram @nomari.studio." },
      features: ["handmade", "custom"],   // feature icon chips (icons.js keys)
      photo: "img/crochet-howto",
      ratio: "3 / 4",
      photoAlt: "How to order · custom gifts",
      stubNote: "Custom → IG DM @nomari.studio",
      variants: [
        { id: "custom", name: "訂製／查詢 Custom enquiry", note: "IG DM @nomari.studio" }
      ]
    }
  ]
};

/* ============================================================
   CUSTOM ORDER 訂製查詢 (brief inquiry form, added 2026-09-30)
   Stored in Site Data collection `custom_inquiries`
   (+ compressed images in `custom_inquiry_images`).
   No Nomari prices here — budget = customer's own range.
   ============================================================ */
window.NOMARI_CONFIG.customOrder = {
  igHandle: "@nomari.studio",
  igUrl: "https://www.instagram.com/nomari.studio/",
  maxImages: 3,
  types: [
    { id: "light-box",     name: "Light box 燈箱",
      examplesRatio: "4 / 5",   // 2026-10-02: *-aligned = crop + uniform scale of raw/light-box/lightbox-0{3,2,4}.jpg, plate same size/position (old Lora retouch files kept); shown whole, no crop
      examples: [
        { photo: "img/lightbox-hero-aligned",  caption: "著燈 Lit",       alt: "Light box 例子：著燈（NOMARI logo 燈箱）" },
        { photo: "img/lightbox-unlit-aligned", caption: "關燈 Unlit",     alt: "Light box 例子：關燈" },
        { photo: "img/lightbox-3q-aligned",    caption: "斜角 3/4 view",  alt: "Light box 例子：斜角，著燈" }
      ] },
    { id: "logo-stand",    name: "Business logo stand 商業 logo 座",
      examples: [
        { photo: "img/logo-stand-hero", caption: "正面 Front",            alt: "Business logo stand 例子：正面" },
        { photo: "img/logo-stand-3q",   caption: "斜角 3/4 view",         alt: "Business logo stand 例子：斜角" },
        { photo: "img/logo-stand-nfc-separated",  caption: "NFC 掣 NFC caps",      alt: "Business logo stand 例子：NFC 掣拎起，底座見到 NFC tag" }
      ] },
    { id: "qr-stand",      name: "QR stand QR 座" },
    { id: "nfc-stand",     name: "NFC button + stand NFC 掣＋座" },
    { id: "other",         name: "其他 Other" }
  ],
  budgets: [
    { id: "",          name: "未諗好／唔肯定 Not sure yet" },
    { id: "under-50",  name: "CAD 50 以下 · Under 50" },
    { id: "50-100",    name: "CAD 50–100" },
    { id: "100-200",   name: "CAD 100–200" },
    { id: "200-500",   name: "CAD 200–500" },
    { id: "500-plus",  name: "CAD 500 以上 · 500+" }
  ]
};
// ---- HIDDEN PRODUCTS (Atash 2026-10-02 19:34 PT): hidden until photos + pricing are done. Remove an id to show it again. ----
// Hidden = gone from the catalog, home featured slider and ?p= links; config entry, prices and admin are untouched.
// 2026-10-18: hk-nostalgia removed from HIDE (re-launch preview).
(function(){ var HIDE = [], C = window.NOMARI_CONFIG;
  C.products = C.products.filter(function(p){ return HIDE.indexOf(p.id) < 0; });
  C.featured = C.featured.filter(function(f){ return HIDE.indexOf(f.product) < 0; }); })();
